import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router';

import { SolaForceCookie, useCookie } from '~/hooks/useCookie';

type PropsType = {
  ignorePaths?: string[];
};

export const HandleCurrentPageCookie = (props: PropsType) => {
  const { ignorePaths } = props;
  const location = useLocation();
  const { value, setValue } = useCookie(SolaForceCookie.CurrentPage);

  const isIgnorePath = useCallback(
    (path: string) => {
      return (
        !!ignorePaths &&
        ignorePaths.filter((p) => path.startsWith(p))?.length > 0
      );
    },
    [ignorePaths],
  );

  useEffect(() => {
    const currentPath = `/v2${location.pathname}`;

    if (value !== currentPath && isIgnorePath(currentPath)) {
      setValue(currentPath);
    }
  }, [location.pathname, value, setValue, isIgnorePath]);

  return null;
};
